import {useEffect, useState, useRef} from "react";
import classes from "./AgoraComponent.module.css";
import {connect} from "react-redux";
import {endAgoraCall} from "../../../actions/ConversationAction";
import {database} from "../../../firebase";
import axios from "axios";
import {firebaseNorthEastRoot, firebaseRoot} from "../../../config";
const attendCall = require('../../../assets/attend_call.png');
const audioCallDisabled = require('../../../assets/audio_call_disabled.png');
const audioCallEnabled = require('../../../assets/audio_call_enabled.png');
const camera = require('../../../assets/camera-icon.png');
const declineCall = require('../../../assets/decline_call.png');
const defaultUser = require('../../../assets/defalt_user.png');
const microphone = require('../../../assets/microphone.png');
const muteCamera = require('../../../assets/mute-camera.png');
const muteMicrophone = require('../../../assets/mute-microphone.png');
const muteSpeaker = require('../../../assets/mute-speaker.png');
const videoCallDisabled = require('../../../assets/video_call_disabled.png');
const videoCallEnabled = require('../../../assets/video_call_enabled.png');
let callLogsRef = null;

const Controls = (props) => {
	const { track, tracks, setStart, setInCall, client, type } = props;
	const [trackState, setTrackState] = useState({ video: true, audio: true });

	// normalize: audioCall passes `track`, videoCall passes `tracks`
	const audioTrack = track || (Array.isArray(tracks) ? tracks[0] : null);
	const videoTrack = Array.isArray(tracks) ? tracks[1] : null;

	const getTrackKind = (t) => {
		try {
			const mst = typeof t?.getMediaStreamTrack === "function" ? t.getMediaStreamTrack() : null;
			if (mst?.kind) return mst.kind;
		} catch (e) {}
		return t?.trackMediaType || "audio";
	};

	const safeSetTrackActive = async (t, active) => {
		if (!t) return;
		const kind = getTrackKind(t);
		const isAudio = kind === "audio" || kind === "audioTrack";

		// audio: prefer setMuted (avoids _enabledMutex crashes)
		if (isAudio) {
			try {
				if (typeof t.setMuted === "function") {
					await t.setMuted(!active);
					return;
				}
			} catch (e) {}
			try {
				if (typeof t.setEnabled === "function") {
					await t.setEnabled(active);
				}
			} catch (e) {}
			return;
		}

		// video
		try {
			if (typeof t.setEnabled === "function") {
				await t.setEnabled(active);
				return;
			}
		} catch (e) {}
		try {
			if (typeof t.setMuted === "function") {
				await t.setMuted(!active);
			}
		} catch (e) {}
	};

	const mute = async (kind) => {
		if (kind === "audio") {
			await safeSetTrackActive(audioTrack, !trackState.audio);
			setTrackState((ps) => ({ ...ps, audio: !ps.audio }));
			return;
		}
		if (kind === "video") {
			await safeSetTrackActive(videoTrack, !trackState.video);
			setTrackState((ps) => ({ ...ps, video: !ps.video }));
			return;
		}
	};

	const conversationId =
		props?.callData?.conversationId ||
		props?.callData?.conversationID ||
		props?.conversationId ||
		null;

	const leavingRef = useRef(false);

	useEffect(() => {
		if (!conversationId) return;
		// Clear stale status (same structure, just set to in_call)
		database
			.ref(`callLogs/${conversationId}/status`)
			.set("in_call")
			.catch(() => {});
	}, [conversationId]);

	const leaveChannel = async (status) => {
		try {
			// ...existing guard logic (if you need it)...
			await client?.leave();
			client?.removeAllListeners?.();

			if (type === "audioCall") {
				track?.close?.();
			} else if (Array.isArray(tracks)) {
				tracks[1]?.close?.();
				tracks[0]?.close?.();
			}

			props.endAgoraCall?.();
			setStart(false);
			setInCall(false);

			try {
				const notificationPayload = {
					notificationToken: props?.selectedPatient?.notificationToken,
					data: {
						ReminderType: props?.callData?.callType === "audio" ? "audioCallEnd" : "videoCallEnd",
					},
				};
				const voipNotificationPayload = {
					production: process.env.NODE_ENV !== "development",
					token: props?.selectedPatient?.voipToken,
					payload: {
						reminderType: props?.callData?.callType === "audio" ? "audioCallEnd" : "videoCallEnd",
					},
				};

				const shouldNotify = async (cb) => {
					if (!props?.callData?.conversationId) return;
					const snap = await database.ref(`callLogs/${props.callData.conversationId}/status`).once("value");
					const currentStatus = snap.val();
					if (currentStatus === "initiated" || currentStatus === "call_ringing") {
						await cb();
					}
				};

				if (
					props?.selectedPatient?.notificationToken &&
					(props?.selectedPatient?.platform || "").toLowerCase() === "android" &&
					props?.callData?.callType
				) {
					await shouldNotify(() =>
						axios.post(`${firebaseRoot}/customCloudMessage`, JSON.stringify(notificationPayload), {
							headers: { "Content-Type": "application/json" },
						})
					);
				}

				if (
					props?.selectedPatient?.voipToken &&
					(props?.selectedPatient?.platform || "").toLowerCase() === "ios" &&
					props?.callData?.callType
				) {
					await shouldNotify(() =>
						axios.post(`${firebaseNorthEastRoot}/callNotificationVOIP`, JSON.stringify(voipNotificationPayload), {
							headers: { "Content-Type": "application/json" },
						})
					);
				}
			} catch (err) {
				console.log("notification error", err);
			}

			if (props?.callData?.conversationId) {
				const updates = {
					[`/callLogs/${props.callData.conversationId}/hostStatus`]: "unavailable",
				};
				if (!status) {
					updates[`/callLogs/${props.callData.conversationId}/status`] = "doctor_ended";
					updates[`/callLogs/${props.callData.conversationId}/events/${Date.now()}`] = "doctor_ended";
				}
				await database.ref().update(updates);
			}
		} catch (e) {
			console.log("leaveChannel error", e);
		}
	};

	useEffect(() => {
		// detach previous listener
		if (callLogsRef) {
			try { callLogsRef.off("value"); } catch (e) {}
			callLogsRef = null;
		}

		if (conversationId) {
			callLogsRef = database.ref(`callLogs/${conversationId}/status`);
			const handler = (snap) => {
				if (leavingRef.current) return;
				const statusRaw = snap.val();
				const status = (statusRaw || "").toString().toLowerCase();
				if (!status) return;

				const remoteEndedStatuses = [
					"patient_ended",
					"patient_declined",
					"client_left",
					"client-left",
					"clientended",
					"user_left",
					"user-left",
					"doctor_ended",
					"doctor_declined",
					"ended",
					"declined"
				];

				if (!remoteEndedStatuses.includes(status)) return;

				leavingRef.current = true;
				leaveChannel(statusRaw)
					.catch((err) => console.log("leaveChannel from listener", err))
					.finally(() => {
						setTimeout(() => {
							leavingRef.current = false;
						}, 800);
					});
			};
			callLogsRef.on("value", handler);

			return () => {
				try { callLogsRef?.off("value", handler); } catch (e) {}
				callLogsRef = null;
			};
		}
	}, [conversationId]); // eslint-disable-line react-hooks/exhaustive-deps

	if (type === "audioCall") {
		return (
			<div className={`controls ${classes.controlSection}`}>
				<img className={classes.icon_image} src={trackState.audio ? microphone : muteMicrophone} alt="" onClick={() => mute("audio")} />
				<img className={classes.icon_image} src={declineCall} alt="" onClick={() => leaveChannel()} />
			</div>
		);
	}

	return (
		<div className={`controls ${classes.controlSection}`}>
			<img className={classes.icon_image} src={trackState.audio ? microphone : muteMicrophone} alt="" onClick={() => mute("audio")} />
			<img className={classes.icon_image} src={trackState.video ? camera : muteCamera} alt="" onClick={() => mute("video")} />
			<img className={classes.icon_image} src={declineCall} alt="" onClick={() => leaveChannel()} />
		</div>
	);
};

const mapStateToProps = ({ conversationReducer }) => {
	const { callData, selectedPatient, conversationId } = conversationReducer;
	return { callData, selectedPatient, conversationId };
};

export default connect(mapStateToProps, { endAgoraCall })(Controls);
